module.exports = __webpack_public_path__ + "static/media/shield.10913172.svg";